import { render, staticRenderFns } from "./book-content-edit.vue?vue&type=template&id=179b4144&scoped=true"
import script from "./book-content-edit.vue?vue&type=script&lang=js"
export * from "./book-content-edit.vue?vue&type=script&lang=js"
import style0 from "./book-content-edit.vue?vue&type=style&index=0&id=179b4144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179b4144",
  null
  
)

/* custom blocks */
import block0 from "./book-content-edit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports